import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LmsService } from "../services/lms.service";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
declare var $: any;
import { SnackbarComponent } from "../../snackbar/snackbar.component";

@Component({
  selector: "app-lms-insurance-renewal",
  templateUrl: "./lms-insurance-renewal.component.html",
  styleUrls: ["./lms-insurance-renewal.component.scss"],
})
export class LmsInsuranceRenewalComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  DateTo: any = new Date();
  DateFrom: any = new Date();
  dataSource: any;
displayedColumnsInsurance: string[] = [
  "InsuranceId",
  "LoanAcNo",
  "Application_No",
  "Product_Name",
  "Loan_Date",
  "Customer",
  "AssetInsuranceDate",
  "AssetRenewalDate",
  "Customer_PhoneNo",
  "VehicleRegistationNo",
  "VehicleModelName",
  "AssetInsuranceCompanyName",
  "AssetInsuranceCompanyBranchName",
  "AssetAgentName",
  "AssetInsuranceEndorsed",
  "AssetPolicyTypeName",
  "AssetIdvAmount",
  "AssetPremiumAmount",
  "Type",
];
  loading: boolean = false;

  @ViewChild("paginator") paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  FileCheckingList: any;

  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Insurance Renewal");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  onSearchInsuranceDetail() {
    this.showSpinner = true;
    this.lmsService
      .LMS_InsuranceRenewalDue_Report({
        fromDate: this.DateFrom,
        toDate: this.DateTo,
      })
      .subscribe(
        (response: any) => {
          this.showSpinner = false;
          if (response && response.length > 0) {
            this.dataSource = new MatTableDataSource(response);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.dataSource = new MatTableDataSource([]);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "No data found",
              ...this.configSuccess,
            });
            this.showSpinner = false;
          }
        },
        (error: any) => {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Error fetching data",
            ...this.configSuccess,
          });
        }
      );
  }
onExport(): void {
  const headerMap: any = {
    InsuranceId: "Insurance ID",
    LoanAcNo: "Loan AC No.",
    Application_No: "Application No",
    Product_Name: "Product Name",
    Loan_Date: "Loan Date",
    Customer: "Customer",
    Customer_PhoneNo: "Customer Phone No",
    VehicleRegistationNo: "Vehicle Registration No",
    VehicleModelName: "Vehicle Model Name",
    AssetInsuranceCompanyName: "Asset Insurance Company Name",
    AssetInsuranceCompanyBranchName: "Asset Insurance Company Branch Name",
    AssetAgentName: "Asset Agent Name",
    AssetInsuranceDate: "Asset Insurance Date",
    AssetRenewalDate: "Asset Renewal Date",
    RenewalDueDate: "Renewal Due Date",
    Remarks: "Remarks",
    AssetInsuranceEndorsed: "Asset Insurance Endorsed",
    AssetPolicyTypeName: "Asset Policy Type Name",
    AssetIdvAmount: "Asset Idv Amount",
    AssetPremiumAmount: "Asset Premium Amount",
    Type: "Type"
  };

  const exportData = this.dataSource.data.map((row: any, index: number) => {
    const obj: any = {};
    obj["S.No."] = index + 1;
    this.displayedColumnsInsurance.forEach((col) => {
      obj[headerMap[col] || col] = row[col];
    });
    return obj;
  });

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
  const workbook: XLSX.WorkBook = {
    Sheets: { "Insurance Renewal": worksheet },
    SheetNames: ["Insurance Renewal"],
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  saveAs(
    new Blob([excelBuffer], { type: "application/octet-stream" }),
    "Insurance_Renewal.xlsx"
  );
}
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
